import { createIcon } from '@chakra-ui/react';

export const Reset = createIcon({
  displayName: 'Reset',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8 2.7998C7.8 2.7998 3.7 6.7998 3.6 11.7998H2L4 13.7998L6 11.7998H4.5C4.6 7.3998 8.3 3.7998 12.7 3.7998C17.2 3.7998 20.9 7.4998 20.9 11.9998C20.9 16.4998 17.2 20.1998 12.7 20.1998C10.4 20.1998 8.2 19.1998 6.7 17.5998C6.5 17.3998 6.2 17.3998 6 17.5998C5.8 17.7998 5.8 18.0998 6 18.2998C7.7 20.0998 10.1 21.1998 12.7 21.1998C17.8 21.1998 21.9 17.0998 21.9 11.9998C21.9 6.8998 17.9 2.7998 12.8 2.7998ZM16.9 15.6998L13.3 12.0998L16.7 8.6998C16.9 8.4998 16.9 8.1998 16.7 8.0998C16.5 7.8998 16.2 7.8998 16.1 8.0998L12.7 11.4998L9 7.8998C8.8 7.6998 8.5 7.6998 8.4 7.8998C8.2 7.9998 8.2 8.2998 8.4 8.4998L12 12.0998L8.6 15.4998C8.4 15.6998 8.4 15.9998 8.6 16.0998C8.8 16.2998 9.1 16.2998 9.2 16.0998L12.6 12.6998L16.2 16.2998C16.4 16.4998 16.7 16.4998 16.8 16.2998C17 16.1998 17 15.8998 16.9 15.6998Z"
      fill="currentColor"
    />
  ),
});
